export enum BookingFilterMode {
  INITIAL = "initial",
  FILTERING = "filtering",
  RESET = "reset"
}
